/**
 * Dashboard Translations
 * ======================
 * Stats, charts, period selector, quick actions
 */

import { Translations } from '../shared/i18n';

export const dashboardTranslations: Translations = {
    tr: {
        // Page
        dashboardTitle: 'Dashboard',
        dashboardDescription: 'Banka Ekstresi, Gider ve Gelir Analitikleri',

        // Stats
        totalExpenses: 'Toplam Harcama',
        matched: 'Eşleşen',
        discrepancies: 'Uyuşmazlık',
        pendingReview: 'İnceleme Bekleyen',

        // Period selector
        periodAll: 'Tümü',
        period1W: '1H',
        period1M: '1A',
        period3M: '3A',
        period1Y: '1Y',
        periodFrom: 'Başlangıç',
        periodTo: 'Bitiş',

        // Charts
        totalSpending: 'Toplam Harcama',
        spendingByCategory: 'Kategoriye Göre Harcama',
        revenueByCategory: 'Kategoriye Göre Gelir',
        loadingData: 'Yükleniyor...',
        noCategoryData: 'Bu dönem için kategori verisi yok',
        pieAmountCol: 'Tutar',
        pieShareCol: 'Pay',
        pieTotal: 'Toplam',

        // Quick actions
        quickActions: 'Hızlı İşlemler',
        expensesAction: 'Harcamalar',
        expensesActionDesc: 'Harcama listesini görüntüle ve yönet',

        // Chart filters
        showValuesIn: 'Gösterilen para birimi:',
        transactionCurrency: 'İşlem para birimi:',
        dateResolution: 'Tarih çözünürlüğü:',
        chartFilters: 'Filtrele',
        filterCurrency: 'Para Birimi',
        filterCategory: 'Kategori',
        selectAll: 'Hepsini Sec',
        deselectAll: 'Temizle',

        // Nav
        navDashboard: 'Dashboard',
        navExpenses: 'Harcamalar',
        navBankStatements: 'Banka Ekstreleri',

        dashboardExpenses: 'Giderler',
        dashboardRevenue: 'Gelirler',
        dashboardInvoices: 'Giderler ve Gelirler',
        totalRevenue: 'Toplam Gelir',

        // Bank dashboard
        bankTotalDebits: 'Toplam Çıkış',
        bankTotalCredits: 'Toplam Giriş',
        bankByBank: 'Banka Bazlı Dağılım',
        bankMatchStatus: 'Eşleşme Durumu',
        bankMatched: 'Eşleşen',
        bankUnmatched: 'Eşleşmeyen',
        bankTotalTransactions: 'Toplam İşlem',
        bankMatchRate: 'Eşleşme Oranı',
        bankUnmatchedTransactions: 'Eşleşmeyen İşlemler',
        bankMatchedTransactions: 'Eşleşen İşlemler',
        bankNoData: 'Bu dönem için banka işlemi bulunamadı',
        bankTxDetail: 'İşlem Detayı',
        bankNoMatchFound: 'Eşleşen döküman bulunamadı',
        bankStatementPreview: 'Banka Ekstresi',
        bankMatchedDocument: 'Eşleşen Döküman',

        // Match detail table
        description: 'Açıklama',
        amount: 'Tutar',
        type: 'Tür',
        matchColumn: 'Eşleşme',
        moreRows: '+{count} daha',
        noSpendingData: 'Bu dönem için harcama verisi yok',
    },
    en: {
        // Page
        dashboardTitle: 'Dashboard',
        dashboardDescription: 'Bank Statement, Expense and Revenue Analytics',

        // Stats
        totalExpenses: 'Total Expenses',
        matched: 'Matched',
        discrepancies: 'Discrepancies',
        pendingReview: 'Pending Review',

        // Period selector
        periodAll: 'All',
        period1W: '1W',
        period1M: '1M',
        period3M: '3M',
        period1Y: '1Y',
        periodFrom: 'From',
        periodTo: 'To',

        // Charts
        totalSpending: 'Total Expenses',
        spendingByCategory: 'Expenses by Category',
        revenueByCategory: 'Revenues by Category',
        loadingData: 'Loading...',
        noCategoryData: 'No category data for this period',
        pieAmountCol: 'Amount',
        pieShareCol: 'Share',
        pieTotal: 'Total',

        // Quick actions
        quickActions: 'Quick Actions',
        expensesAction: 'Expenses',
        expensesActionDesc: 'View and manage expense list',

        // Chart filters
        showValuesIn: 'Show values in:',
        transactionCurrency: 'Transaction currency:',
        dateResolution: 'Date resolution:',
        chartFilters: 'Filter',
        filterCurrency: 'Currency',
        filterCategory: 'Category',
        selectAll: 'Select All',
        deselectAll: 'Clear',

        // Nav
        navDashboard: 'Dashboard',
        navExpenses: 'Expenses',
        navBankStatements: 'Bank Statements',

        dashboardExpenses: 'Expenses',
        dashboardRevenue: 'Revenues',
        dashboardInvoices: 'Expenses & Revenues',
        totalRevenue: 'Total Revenues',

        // Bank dashboard
        bankTotalDebits: 'Total Outgoing',
        bankTotalCredits: 'Total Incoming',
        bankByBank: 'By Bank',
        bankMatchStatus: 'Match Status',
        bankMatched: 'Matched',
        bankUnmatched: 'Unmatched',
        bankTotalTransactions: 'Total Transactions',
        bankMatchRate: 'Match Rate',
        bankUnmatchedTransactions: 'Unmatched Transactions',
        bankMatchedTransactions: 'Matched Transactions',
        bankNoData: 'No bank transactions found for this period',
        bankTxDetail: 'Transaction Detail',
        bankNoMatchFound: 'No matching document found',
        bankStatementPreview: 'Bank Statement',
        bankMatchedDocument: 'Matched Document',

        // Match detail table
        description: 'Description',
        amount: 'Amount',
        type: 'Type',
        matchColumn: 'Match',
        moreRows: '+{count} more',
        noSpendingData: 'No spending data for this period',
    },
    de: {
        // Page
        dashboardTitle: 'Dashboard',
        dashboardDescription: 'Kontoauszug, Ausgaben- und Einnahmenanalyse',

        // Stats
        totalExpenses: 'Gesamtausgaben',
        matched: 'Zugeordnet',
        discrepancies: 'Abweichungen',
        pendingReview: 'Zur Prüfung',

        // Period selector
        periodAll: 'Alle',
        period1W: '1W',
        period1M: '1M',
        period3M: '3M',
        period1Y: '1J',
        periodFrom: 'Von',
        periodTo: 'Bis',

        // Charts
        totalSpending: 'Gesamtausgaben',
        spendingByCategory: 'Ausgaben nach Kategorie',
        revenueByCategory: 'Einnahmen nach Kategorie',
        loadingData: 'Wird geladen...',
        noCategoryData: 'Keine Kategoriedaten für diesen Zeitraum',
        pieAmountCol: 'Betrag',
        pieShareCol: 'Anteil',
        pieTotal: 'Gesamt',

        // Quick actions
        quickActions: 'Schnellzugriff',
        expensesAction: 'Ausgaben',
        expensesActionDesc: 'Ausgabenliste anzeigen und verwalten',

        // Chart filters
        showValuesIn: 'Werte anzeigen in:',
        transactionCurrency: 'Transaktionswährung:',
        dateResolution: 'Datumsauflösung:',
        chartFilters: 'Filter',
        filterCurrency: 'Wahrung',
        filterCategory: 'Kategorie',
        selectAll: 'Alle',
        deselectAll: 'Loschen',

        // Nav
        navDashboard: 'Dashboard',
        navExpenses: 'Ausgaben',
        navBankStatements: 'Kontoauszüge',

        dashboardExpenses: 'Ausgaben',
        dashboardRevenue: 'Einnahmen',
        dashboardInvoices: 'Ausgaben & Einnahmen',
        totalRevenue: 'Gesamteinnahmen',

        // Bank dashboard
        bankTotalDebits: 'Gesamte Ausgänge',
        bankTotalCredits: 'Gesamte Eingänge',
        bankByBank: 'Nach Bank',
        bankMatchStatus: 'Zuordnungsstatus',
        bankMatched: 'Zugeordnet',
        bankUnmatched: 'Nicht zugeordnet',
        bankTotalTransactions: 'Gesamttransaktionen',
        bankMatchRate: 'Zuordnungsrate',
        bankUnmatchedTransactions: 'Nicht abgeglichene Transaktionen',
        bankMatchedTransactions: 'Abgeglichene Transaktionen',
        bankNoData: 'Keine Banktransaktionen für diesen Zeitraum',
        bankTxDetail: 'Transaktionsdetail',
        bankNoMatchFound: 'Kein passendes Dokument gefunden',
        bankStatementPreview: 'Kontoauszug',
        bankMatchedDocument: 'Zugeordnetes Dokument',

        // Match detail table
        description: 'Beschreibung',
        amount: 'Betrag',
        type: 'Typ',
        matchColumn: 'Zuordnung',
        moreRows: '+{count} weitere',
        noSpendingData: 'Keine Ausgabendaten für diesen Zeitraum',
    },
};